/**
 * Shared static application state, extracted from AppModule to break the
 * BaseComponent → AppModule → PagesLayoutModule → ValidationPopupComponent → BaseComponent
 * circular dependency that prevents Karma from loading the test bundle.
 *
 * AppModule and BaseComponent both import this file; neither imports the other.
 */
export const AppState = {
  instanceInfo: {} as any,
  companyInfo: {} as any,
  pagesLoading: false as boolean,
};
